var _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEbl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_x5F_Pantone",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "426.614px",
    height: "327.401px",
    viewBox: "0 0 426.614 327.401",
    enableBackground: "new 0 0 426.614 327.401",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.467,274.802"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 426.614,
    height: 327.401
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#737A7F",
    d: "M0.708,275.105c0.335-28.89,20.307-33.596,39.685-34.272c7.668-0.268,15.552-0.06,24.345,0.113    c28.623,0.563,41.603,8.936,41.976,34.159c0.081,5.489-0.274,11.622-0.274,11.622H14.598l0,5.807    c0,15.562,7.009,21.814,27.212,22.256c6.251,0.137,13.715,0.3,23.787,0c20.055-0.597,25.821-1.619,25.793-15.727l14.378,0.035    c-0.066,22.438-12.646,26.951-42.877,27.594c0,0-14.832,0.224-22.529,0c-19.421-0.564-39.314-5.25-39.649-34.158    C0.63,285.424,0.627,282.101,0.708,275.105z M92.835,272.591c0-14.423-7.376-19.261-29.598-19.878    c-6.669-0.186-15.378-0.183-21.375,0c-20.25,0.617-27.263,6.83-27.263,22.676h78.237V272.591z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737A7F",
    d: "M231.621,275.105c-0.335-28.89-20.308-33.596-39.687-34.272c-3.97-0.139-19.352-0.126-23.322,0    c-21.25,0.677-27.948,10.192-27.948,10.192l-0.584,0.003v-32.332h-13.904c0,0-0.004,68.831,0.054,73.838    c0.335,28.908,20.228,33.594,39.649,34.158c3.119,0.091,22.968,0.091,26.087,0c19.421-0.564,39.316-5.25,39.65-34.158    C231.699,285.424,231.702,282.101,231.621,275.105z M217.731,292.534c0,15.562-7.011,21.814-27.214,22.256    c-4.493,0.098-20.101,0.067-23.189,0c-20.203-0.441-27.212-6.694-27.212-22.256l0-17.146c0-15.846,7.014-22.059,27.263-22.676    c2.956-0.09,20.132-0.09,23.088,0c20.25,0.617,27.265,6.83,27.265,22.676V292.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#737A7F",
    d: "M265.297,287.774c0,19.36,6.978,26.03,29.419,26.03c1.82,0,2.43,0.085,8.135-0.319l-0.107,12.927    c0,0-4.814,0.28-11.856,0.28c-19.962,0-39.476-7.007-39.476-34.813l-0.055-73.184h13.904L265.297,287.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E6994F",
    cx: 417.105,
    cy: 9.509,
    r: 8.801
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6994F",
    cx: 363.872,
    cy: 234.734,
    r: 19.807
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6994F",
    cx: 384.223,
    cy: 275.749,
    r: 13.748
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6994F",
    cx: 222.646,
    cy: 127.35,
    r: 11.423
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E6994F",
    cx: 391.548,
    cy: 50.468,
    r: 15.442
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6994F",
    d: "M334.504,101.12c-2.395,23.68-22.055,41.165-52.56,21.946v0.001c-3.478-2.385-7.682-3.786-12.217-3.786    c-11.947,0-21.633,9.686-21.633,21.633s9.686,21.632,21.633,21.632c1.281,0,2.523-0.106,3.743-0.319    c21.044-3.682,33.136,3.915,36.628,24.246c2.442,12.816,13.699,22.504,27.223,22.504c15.311,0,27.724-12.411,27.724-27.722    c0-5.458-1.584-10.543-4.308-14.833l0.025-0.01c-13.323-19.045-7.672-32.824,8.469-41.335c7.813-4.12,13.271-12.108,13.271-21.541    c0-13.292-10.776-24.067-24.067-24.067C345.306,79.47,335.756,88.736,334.504,101.12z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEbl);
export default __webpack_public_path__ + "static/media/logo_ebl.8bff50f2f7bbc519410cdf1fa7454aa3.svg";
export { ForwardRef as ReactComponent };